module.exports = __webpack_public_path__ + "img/5.0b37e4d1.png";